<template>
    <div class="wrap-service-consulting">
        <header-app></header-app>
        <div class="consulting-banner"></div>
        <div class="consult-detail animation">
            <h3 class="consult-title">CONSULTING</h3>
            <div id="main2" v-html="info.content">
                <!-- div class="consult-item">
                    <p class="has-icon">Trout & Partners, Enterprise's New Venture Partner</p>
                    <div class="consult-text">
                        Trout & Partners is committed to creating a global optimal
                        positioning practice to help enterprises lead in the strategy with
                        positioning theory and achieve a system of operation with
                        increased efficiency. <br />
                        Our vision and target are to enter different industries, integrate
                        positioning knowledge into enterprise management, and create
                        leading brands in various industries, in a way that promotes the
                        follow-up and popularization of positioning theory.
                    </div>
                </div>
                <div class="consult-item">
                    <p class="has-icon has-icon-1">Objectives</p>
                    <div class="consult-text">
                        Trout & Partners is committed to creating a global optimal
                        positioning practice to help enterprises lead in the strategy with
                        positioning theory and achieve a system of operation with
                        increased efficiency. <br />
                        Our vision and target are to enter different industries, integrate
                        positioning knowledge into enterprise management, and create
                        leading brands in various industries, in a way that promotes the
                        follow-up and popularization of positioning theory.
                    </div>
                </div>
                <div class="consult-item">
                    <p class="has-icon has-icon-2">Partners</p>
                    <div class="consult-text">
                        Based on the goal of creating a model for the industry while
                        taking into account the cooperation approaches of business
                        partners, our best partners will be enterprises that innovate and
                        start their own businesses with optimal operations and great
                        vision.
                    </div>
                </div>
                <div class="consult-item">
                    <p class="has-icon has-icon-3">Work description</p>
                    <div class="consult-text">
                        The goal of Trout & Partners is primarily to systematically
                        integrate positioning theory into enterprise management. First, it
                        guides the decision-making process of various strategies of each
                        enterprise, and second, it helps entrepreneurs to establish
                        strategic positioning thinking in a way that gradually changes the
                        business model of enterprises, enhancing their strategic
                        capabilities and developing their advantages. <br />
                        In each cooperative process, enterprises are facing various issues, based on their own situations; the actual work is not limited to the following.
                    </div>
                    <div class="consult-second-text">
                        <p>
                            Clarify the business direction and find the main opportunities
                        </p>
                        <div>
                            Systematically sort out the strategic situation of the
                            enterprise and the basis of its own operation; clarify the
                            strategic direction of the enterprise and find the main
                            opportunities.
                        </div>
                        <p>Clarify value and establish positioning</p>
                        <div>
                            Based on the strategic direction of each enterprise, clarify and
                            effectively transform the value of enterprise innovation and
                            differentiation, establish its positioning and clarify its
                            strategic core.
                        </div>
                        <p>Configure resources around positioning</p>
                        <div>
                            Trout & Partners will focus on the positioning of each
                            enterprise, guide enterprises to allocate various resources,
                            carry out planning and operations, and realize the efficient
                            operation.
                        </div>
                        <p>Lead the competition and reshape the industry</p>
                        <div>
                            In the process of strategy implementation, conduct a systematic
                            evaluation, research and formulate response strategies for
                            competitor's actions of defense, follow-up, and attack, etc. In
                            addition, through strategic advancement, lead the competition,
                            establish new standards, and reshape the industry. Discover and
                            seize new opportunities
                        </div>
                        <p>Discover and seize new opportunities</p>
                        <div>
                            With the advancement of strategies, enterprises need to carry
                            out innovation and may meet new opportunities and challenges
                            such as product upgrading and business evolution, etc. In this
                            process, Trout & Partners will guide and transform the
                            innovation of enterprises and grasp new opportunities so as to
                            achieve greater development and sustained growth.
                        </div>
                    </div>
                </div>
                <div class="consult-item">
                    <p class="has-icon has-icon-4">Establish cooperation</p>
                    <div class="consult-text">
                        Due to the professionalism of positioning theory, the cooperation
                        between Trout & Partners and enterprises calls for mutual
                        understanding and trust; both parties should reach a consensus on
                        the vision of each enterprises future development, to establish
                        sound and effective cooperation. <br />
                        Based on the current situation of the enterprise, we determine
                        what value we can bring to an enterprise, and conduct professional
                        discussions to confirm final cooperation plan through efficient
                        communication with the enterprise.
                    </div>
                </div -->
            </div>
        </div>
        <bottom-app></bottom-app>
        <top-scroll></top-scroll>
    </div>
</template>

<script>
    import headerApp from '@/components/headerApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import bottomApp from '@/components/bottomApp.vue'
    export default {
        data () {
            return {
                info: {}
            }
        },
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        created(){
            this.$api.consultingList().then((res)=>{
                if(res){
                    console.log(res);
                    this.info = res.list[0]
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-service-consulting{
        text-align: left;
        .consulting-banner{
            width: 100%;
            height:7rem;
            background: url(../../assets/imgs/add-introduce.jpg) no-repeat top center;
            background-size: cover;
        }
        .consult-detail{
            background: #fff;
            -webkit-box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.15);
            box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.15);
            margin: -5.6rem 0.4rem 2rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding: 0.4rem;
            .consult-title {
                font-size: 0.48rem;
                color: #6b6b6b;
                line-height: 0.6rem;
                font-weight: 600;
                padding-bottom: 0.3rem;
                position: relative;
                margin-bottom: 0.3rem;
                z-index: 1;
                &:after {
                    content: " ";
                    height: 0.05rem;
                    background: #ea2228;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index: 2;
                    animation: line-left-in-long 0.5s ease 0s;
                    animation-fill-mode: both;
                }

            }
            .consult-item {
                margin-bottom: 0.7rem;
                &:first-child{
                    .has-icon{
                        padding-left: 0;
                    }
                }
                .no-icon {
                    font-size: 0.24rem;
                    color: #2d2d2d;
                    line-height: 0.4rem;
                    font-weight: 600;
                }
                .consult-text {
                    color: #2d2d2d;
                    font-size: 0.28rem;
                    line-height: 1.5;
                    // text-align: justify;
                    padding-top: .2rem;
                }
                .has-icon {
                    font-size: 0.28rem;
                    color: #2d2d2d;
                    line-height: 0.4rem;
                     padding-left: 0.5rem;
                    position: relative;
                    font-weight: 600;
                }
                .has-icon-1::after {
                    content: " ";
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: url(../../assets/imgs/add-intro-icon.png) no-repeat;
                    background-size: 1.81rem 0.34rem;
                    width: 0.4rem;
                    height: 0.4rem;
                    background-position: -0.91rem 0.02rem;
                }
                .has-icon-2::after {
                    content: " ";
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: url(../../assets/imgs/add-intro-icon.png) no-repeat;
                    background-size: 1.81rem 0.34rem;
                    width: 0.4rem;
                    height: 0.4rem;
                    background-position: -1.4rem 0.02rem;
                }
                .has-icon-3::after {
                    content: " ";
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: url(../../assets/imgs/add-intro-icon.png) no-repeat;
                    background-size: 1.81rem 0.34rem;
                    width: 0.4rem;
                    height: 0.4rem;
                    background-position: -0.4rem 0.02rem;
                }
                .has-icon-4::after {
                    content: " ";
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: url(../../assets/imgs/add-intro-icon.png) no-repeat;
                    background-size: 1.81rem 0.34rem;
                    width: 0.4rem;
                    height: 0.4rem;
                    background-position: 0.07rem 0.02rem;
                }
                .consult-second-text{
                    padding-left: 0.3rem;
                    font-size: .24rem;
                    color: #2d2d2d;
                    margin-top: .4rem;
                    text-align: justify;
                    p{
                        line-height: 1.5;
                        font-size: .28rem;
                        font-weight: 600;
                    }
                    div{
                        line-height: 1.5;
                    }
                }
            }
            img {
                max-width: 100%;
            }
            h2 {
                display: inline-block;
                height: .4rem;
                line-height: .4rem;

                img {
                    height: .3rem;
                    padding: .05rem;
                }
            }
        }
    }
</style>
